export default "__VITE_ASSET__CwDt98wP__"